export default __webpack_public_path__ + "static/media/481.c58c4878.jpg";